import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import styles from "./circledicon.module.css";
interface Props {
  icon: ReactNode;
  className?: string;
}
const CircledIcon = t0 => {
  const $ = _c(5);
  const {
    icon,
    className
  } = t0;
  const t1 = `w-16 ${className}`;
  let t2;
  if ($[0] !== icon) {
    t2 = <span className={styles.circle} aria-hidden={true}>{icon}</span>;
    $[0] = icon;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default CircledIcon;